
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13.5","cy":"13.5","r":"13.5","fill":"#E4EAF4"}}),_c('g',{attrs:{"clip-path":"url(#clip0_396_2624)","stroke":"#243041","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21.291 7.833v4.25h-4.25M5.708 19.167v-4.25h4.25"}}),_c('path',{attrs:{"d":"M7.486 11.375a6.375 6.375 0 0110.52-2.38l3.286 3.089M5.708 14.917l3.287 3.088a6.377 6.377 0 0010.519-2.38"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_396_2624"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(5 5)","d":"M0 0h17v17H0z"}})])])])
          )
        }
      }
    